import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';

const GOOGLE_PLACES_API_KEY = 'AIzaSyASXZSrsvL25WiY7nZc2M4WJhkDMj-jkvs';
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function loadAsyncScript(src) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

const extractAddress = place => {
  const address = {
    street_number: '',
    route: '',
    locality: '',
    administrative_area_level_3: '',
    administrative_area_level_2: '',
    administrative_area_level_1: '',
    country: '',
    postal_code: '',
    postal_code_suffix: '',
    latitude: '',
    longitude: '',
    plain() {
      const street_number = this.street_number ? this.street_number + ', ' : '';
      const route = this.route ? this.route + ', ' : '';
      const locality = this.locality ? this.locality + ', ' : '';
      const administrative_area_level_3 = this.administrative_area_level_3
        ? this.administrative_area_level_3 + ', '
        : '';
      const administrative_area_level_2 = this.administrative_area_level_2
        ? this.administrative_area_level_2 + ', '
        : '';
      const administrative_area_level_1 = this.administrative_area_level_1
        ? this.administrative_area_level_1 + ', '
        : '';
      const country = this.country ? this.country + ', ' : '';
      const postal_code = this.postal_code ? this.postal_code + ', ' : '';
      const postal_code_suffix = this.postal_code_suffix
        ? this.postal_code_suffix + ', '
        : '';
      return (
        street_number +
        route +
        locality +
        administrative_area_level_3 +
        administrative_area_level_2 +
        administrative_area_level_1 +
        country +
        postal_code +
        postal_code_suffix
      );
    }
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }

  place.address_components.forEach(component => {
    const types = component.types;
    const value = component.long_name;

    if (types.includes('street_number')) {
      address.street_number = value;
    }
    if (types.includes('route')) {
      address.route = value;
    }
    if (types.includes('locality')) {
      address.locality = value;
    }
    if (types.includes('administrative_area_level_3')) {
      address.administrative_area_level_3 = value;
    }
    if (types.includes('administrative_area_level_2')) {
      address.administrative_area_level_2 = value;
    }
    if (types.includes('administrative_area_level_1')) {
      address.administrative_area_level_1 = value;
    }
    if (types.includes('country')) {
      address.country = value;
    }
    if (types.includes('postal_code')) {
      address.postal_code = value;
    }
    if (types.includes('postal_code_suffix')) {
      address.postal_code_suffix = value;
    }
  });

  let points = Object.keys(place?.geometry?.viewport);

  address.latitude = place?.geometry?.viewport?.[points[0]]?.lo;
  address.longitude = place?.geometry?.viewport?.[points[1]]?.lo;

  return address;
};

function Create_Location({
  newLocation,
  handleInputChangeNewData,
  updateLocation,
  setAddRecord,
  setNewLocation
}) {
  const searchInput = useRef(null);

  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${GOOGLE_PLACES_API_KEY}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  const onChangeAddress = autocomplete => {
    const place = autocomplete.getPlace();
    // setAddress(extractAddress(place));
    handleInputChangeNewData({
      target: {
        name: 'location_fullAddress',
        value:
          extractAddress(place)?.street_number +
          ', ' +
          extractAddress(place)?.route +
          ', ' +
          extractAddress(place)?.locality +
          ', ' +
          extractAddress(place)?.administrative_area_level_3 +
          ', ' +
          extractAddress(place)?.administrative_area_level_2 +
          ', ' +
          extractAddress(place)?.administrative_area_level_1 +
          ', ' +
          extractAddress(place)?.country +
          ', ' +
          extractAddress(place)?.postal_code +
          ', ' +
          extractAddress(place)?.postal_code_suffix
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'location_city',
        value: extractAddress(place)?.administrative_area_level_2
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'location_state',
        value: extractAddress(place)?.administrative_area_level_1
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'location_zipCode',
        value: extractAddress(place)?.postal_code
      }
    });

    handleInputChangeNewData({
      target: {
        name: 'location_country',
        value: extractAddress(place)?.country
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'latitude',
        value: extractAddress(place)?.latitude
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'longitude',
        value: extractAddress(place)?.longitude
      }
    });
    // console.log({
    //   fullAddress: extractAddress(place)?.street_number + ", " +
    //     extractAddress(place)?.route + ", " +
    //     extractAddress(place)?.locality + ", " +
    //     extractAddress(place)?.administrative_area_level_3 + ", " +
    //     extractAddress(place)?.administrative_area_level_2 + ", " +
    //     extractAddress(place)?.administrative_area_level_1 + ", " +
    //     extractAddress(place)?.country + ", " +
    //     extractAddress(place)?.postal_code + ", " +
    //     extractAddress(place)?.postal_code_suffix,
    //   latitude: extractAddress(place)?.latitude,
    //   longitude: extractAddress(place)?.longitude,
    // })
  };

  const initAutocomplete = () => {
    if (!searchInput.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current
    );
    autocomplete.setFields(['address_component', 'geometry']);
    autocomplete.addListener('place_changed', () =>
      onChangeAddress(autocomplete)
    );
  };

  useEffect(() => {
    initMapScript().then(() => initAutocomplete());
  }, []);

  const [validated, setValidated] = useState(false);

  const handleSubmit = event => {
    event.preventDefault(); // Prevent default form submission behavior

    const form = event.currentTarget;
    // console.log(form.checkValidity());
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    updateLocation();
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <h5 className="mb-0">Create New Location</h5>{' '}
      </Card.Header>
      <Card.Body>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="location_id">
              <Form.Label>Location Id</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Location Id"
                name="location_id"
                value={newLocation?.location_id}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a Location Id.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="location_fullAddress">
              <Form.Label>Full Address</Form.Label>
              <Form.Control
                required
                ref={searchInput}
                contentEditable={false}
                type="text"
                placeholder="Full Address"
                value={newLocation?.location_fullAddress}
                name="location_fullAddress"
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please choose a full address.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Flex className="mt-2">
            <Button type="submit">{'Create Location'}</Button>
            <Button
              onClick={() => {
                setNewLocation({
                  location_id: '',
                  location_city: '',
                  location_state: '',
                  location_country: '',
                  location_zipCode: 0,
                  location_fullAddress: '',
                  latitude: '',
                  longitude: ''
                });
                setAddRecord(false);
              }}
              variant="secondary"
              className="mx-2"
            >
              Close
            </Button>
          </Flex>
        </Form>
      </Card.Body>
    </Card>
  );
}

Create_Location.propTypes = {
  newLocation: PropTypes.any,
  handleInputChangeNewData: PropTypes.any,
  updateLocation: PropTypes.any,
  setAddRecord: PropTypes.any,
  setNewLocation: PropTypes.any
};

export default Create_Location;
